import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertService } from '@mp-core/services/alert.service';
import { AuthService } from '@mp-core/services/auth.service';
import { Constants } from '@mp-core/enums/constants';

@Component({
  selector: 'mp-sign-in-dialog',
  templateUrl: './sign-in-dialog.component.html',
  styleUrls: ['./sign-in-dialog.component.scss'],
})
export class SignInDialogComponent implements OnInit {
  email: FormControl;
  isLoading = false;
  otp: FormControl;
  otpSent: boolean = false;
  isResendActive: boolean = false;
  timer: any;
  otpTimeLeft: number = 30;

  constructor(
    private matDialogRef: MatDialogRef<SignInDialogComponent>,
    private authService: AuthService,
    private alertService: AlertService,
    private router: Router) {
  }

  ngOnInit() {
    this.otp = new FormControl('', [Validators.required, Validators.pattern(`^\\d{6}$`)]);
    this.email = new FormControl('', [Validators.required, Validators.email]);
  }

  onContinue(): void {
    console.log(this.email.errors, this.email.valid);
    if (this.email.valid) {
      this.isLoading = true;
      this.authService.requestOtp(this.email.value).subscribe((res) => {
        console.log(res);
        this.alertService.success('Otp sent', 2000);
        this.otpSent = true;
        // this.startOtpTimer();
        this.isLoading = false;
      }, error => {
        this.isLoading = false;
        console.log(error);
        this.otpSent = false;
        this.alertService.error('Otp not sent');
      });
    }
  }

  verifyOtp() {
    if (this.otpSent && this.otp.valid) {
      this.isLoading = true;
      this.authService.verifyOtp(this.email.value, this.otp.value).subscribe((res) => {
        console.log(res);
        localStorage.setItem(Constants.CURRENT_USER_PHONE_NO, this.email.value);
        this.isLoading = false;
        this.matDialogRef.close();
        this.router.navigateByUrl('/dashboard').then();
      }, error => {
        console.log(error);
        this.isLoading = false;
        this.alertService.error('Wrong OTP. Please try again');
        this.otp.reset();
      });
    }
  }

  startOtpTimer() {
    this.isResendActive = false;
    this.otpTimeLeft = 30;
    this.timer = setInterval(() => {
      if (this.otpTimeLeft === 1) {
        this.isResendActive = true;
        clearInterval(this.timer);
      }
      this.otpTimeLeft--;
    }, 1000);
  }
}
